<svg preserveAspectRatio="none" overflow="visible" style="display: block;" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle id="Ellipse 715" cx="50" cy="50" r="50" fill="#3872FF" fill-opacity="0.12"/>
</svg>
